// Mock data for Munoret

export const jobListings = [
  {
    id: 1,
    title: "Procurement Manager – Renewable Construction",
    company: "Confidential",
    location: "Phoenix, AZ",
    type: "Permanent",
    category: "Engineering",
    salary: "$115,000 - $145,000",
    description: "Lead procurement operations for utility-scale solar and wind construction projects. Manage vendor relationships, contract negotiations, and supply chain optimization for renewable energy infrastructure.",
    requirements: ["7+ years procurement experience in construction/energy", "Experience with renewable energy projects (solar/wind)", "Strong negotiation and contract management skills", "ERP system proficiency (SAP or Oracle)", "Understanding of international sourcing and logistics", "Bachelor's degree in Supply Chain or related field", "Risk management and mitigation expertise"],
    postedDate: "2025-01-25"
  },
  {
    id: 26,
    title: "Senior Manager, Cost Control – EPC",
    company: "Confidential",
    location: "Houston, TX",
    type: "Permanent",
    category: "Engineering",
    salary: "$135,000 - $170,000",
    description: "Oversee cost control functions for large-scale EPC projects exceeding $500M. Implement earned value management systems, analyze cost performance, and provide forecasting for capital projects.",
    requirements: ["10+ years cost control/estimating experience in EPC", "Expert knowledge of earned value management (EVM)", "Experience with Primavera P6 and cost management software", "Strong analytical and forecasting capabilities", "PE or PMP certification preferred", "Proficiency in budget variance analysis", "Experience with $500M+ capital projects"],
    postedDate: "2025-01-24"
  },
  {
    id: 27,
    title: "Project Manager – EPC Energy",
    company: "Confidential",
    location: "Dallas, TX",
    type: "Permanent",
    category: "Engineering",
    salary: "$125,000 - $160,000",
    description: "Manage execution of energy infrastructure projects from engineering through commissioning. Lead multidisciplinary teams for power generation, transmission, and distribution facilities.",
    requirements: ["8+ years project management in energy EPC", "Experience with power plant or substation projects", "PMP certification required", "Strong understanding of electrical systems and codes", "Excellent stakeholder management skills", "Bachelor's degree in Engineering", "Proficiency with MS Project and scheduling tools"],
    postedDate: "2025-01-23"
  },
  {
    id: 28,
    title: "Estimator – LNG",
    company: "Confidential",
    location: "Corpus Christi, TX",
    type: "Permanent",
    category: "Engineering",
    salary: "$100,000 - $130,000",
    description: "Develop detailed cost estimates for LNG facility construction and brownfield expansion projects. Analyze drawings, specifications, and perform quantity takeoffs for liquefaction and regasification facilities.",
    requirements: ["5+ years estimating experience in oil & gas or LNG", "Knowledge of LNG process equipment and cryogenic systems", "Proficiency in estimating software (CostX, On-Screen Takeoff)", "Understanding of FEED and EPC project phases", "Strong attention to detail and analytical skills", "Experience with quantity takeoff and cost databases", "Familiarity with API and ASME standards"],
    postedDate: "2025-01-22"
  },
  {
    id: 25,
    title: "Senior Software Engineer",
    company: "Confidential",
    location: "San Francisco, CA",
    type: "Permanent",
    category: "Technology",
    salary: "$140,000 - $180,000",
    description: "Leading tech company seeking an experienced software engineer to join their core platform team. Work on cutting-edge cloud technologies.",
    requirements: ["5+ years of software development experience", "Strong proficiency in Python, Java, or Go", "Experience with cloud platforms (AWS/GCP/Azure)", "Excellent problem-solving skills", "BS/MS in Computer Science or equivalent", "Experience with microservices architecture", "Strong knowledge of CI/CD pipelines"],
    postedDate: "2025-01-15"
  },
  {
    id: 26,
    title: "Marketing Director",
    company: "Confidential",
    location: "New York, NY",
    type: "Permanent",
    category: "Marketing",
    salary: "$120,000 - $150,000",
    description: "Drive marketing strategy and lead a talented team. Excellent opportunity for a strategic marketing leader.",
    requirements: ["8+ years marketing experience", "Proven track record in brand building", "Team leadership experience", "Strong analytical skills", "MBA or equivalent preferred", "Digital marketing and SEO expertise", "Budget management experience ($1M+)"],
    postedDate: "2025-01-12"
  },
  {
    id: 27,
    title: "Financial Analyst",
    company: "Finance Solutions LLC",
    location: "Chicago, IL",
    type: "Contract",
    category: "Finance",
    salary: "$80,000 - $100,000",
    description: "6-month contract position for financial modeling and analysis. Great opportunity to work with Fortune 500 clients.",
    requirements: ["3+ years financial analysis experience", "Advanced Excel skills", "CFA or MBA preferred", "Strong communication skills", "Experience with financial modeling", "Knowledge of Bloomberg and Capital IQ", "Understanding of valuation methodologies"],
    postedDate: "2025-01-10"
  },
  {
    id: 28,
    title: "HR Business Partner",
    company: "Confidential",
    location: "Remote",
    type: "Permanent",
    category: "Human Resources",
    salary: "$90,000 - $110,000",
    description: "Strategic HR partner to support business units. Focus on talent development and organizational effectiveness.",
    requirements: ["5+ years HR experience", "SHRM-CP or PHR certification", "Experience in retail or consumer goods", "Strong interpersonal skills", "Bachelor's degree in HR or related field", "Experience with HRIS systems", "Knowledge of labor laws and compliance"],
    postedDate: "2025-01-08"
  },
  {
    id: 25,
    title: "Data Scientist",
    company: "Analytics Pro",
    location: "Boston, MA",
    type: "Permanent",
    category: "Technology",
    salary: "$130,000 - $160,000",
    description: "Join our data science team to build predictive models and drive business insights using machine learning.",
    requirements: ["MS/PhD in Computer Science, Statistics, or related field", "3+ years data science experience", "Python, R, SQL proficiency", "Machine learning expertise", "Experience with TensorFlow or PyTorch", "Strong statistical analysis background", "Experience with big data technologies (Hadoop/Spark)"],
    postedDate: "2025-01-05"
  },
  {
    id: 26,
    title: "Operations Manager",
    company: "Confidential",
    location: "Dallas, TX",
    type: "Temporary",
    category: "Operations",
    salary: "$70,000 - $85,000",
    description: "3-month temporary assignment to manage warehouse operations during expansion phase.",
    requirements: ["5+ years operations management", "Lean/Six Sigma certification preferred", "Experience in logistics or supply chain", "Leadership skills", "Bachelor's degree in Operations or related field", "WMS and inventory management experience", "Strong process improvement background"],
    postedDate: "2025-01-03"
  },
  {
    id: 27,
    title: "Chief Technology Officer",
    company: "Confidential",
    location: "Austin, TX",
    type: "Executive",
    category: "Technology",
    salary: "$200,000 - $250,000 + Equity",
    description: "Executive search for CTO to lead technology vision and build engineering team for fast-growing startup.",
    requirements: ["10+ years technology leadership", "Startup experience required", "Strong technical architecture skills", "Proven team builder", "Bachelor's/Master's in Computer Science", "Experience scaling engineering teams", "Track record of successful product launches"],
    postedDate: "2025-01-01"
  },
  {
    id: 28,
    title: "Sales Representative",
    company: "Medical Devices Inc.",
    location: "Los Angeles, CA",
    type: "Permanent",
    category: "Sales",
    salary: "$60,000 - $80,000 + Commission",
    description: "Sell innovative medical devices to hospitals and healthcare facilities. Excellent earning potential.",
    requirements: ["2+ years B2B sales experience", "Healthcare industry knowledge preferred", "Strong presentation skills", "Valid driver's license", "Bachelor's degree preferred", "CRM proficiency (Salesforce)", "Proven track record meeting quotas"],
    postedDate: "2024-12-28"
  },
  {
    id: 25,
    title: "Product Manager",
    company: "Confidential",
    location: "Seattle, WA",
    type: "Permanent",
    category: "Technology",
    salary: "$130,000 - $160,000",
    description: "Lead product strategy and roadmap for enterprise SaaS platform. Work with cross-functional teams to deliver customer value.",
    requirements: ["5+ years product management experience", "B2B SaaS background", "Strong analytical and communication skills", "Experience with Agile methodologies", "Bachelor's degree in Business or Technical field", "User research and data analysis skills", "Roadmap and backlog management"],
    postedDate: "2025-01-20"
  },
  {
    id: 26,
    title: "Compliance Officer",
    company: "Confidential",
    location: "Charlotte, NC",
    type: "Permanent",
    category: "Finance",
    salary: "$100,000 - $125,000",
    description: "Ensure regulatory compliance and manage risk assessment processes for financial services organization.",
    requirements: ["7+ years compliance experience in financial services", "Knowledge of SEC, FINRA regulations", "Strong attention to detail", "Excellent written communication", "Bachelor's degree in Finance or Law", "Experience with compliance management systems", "Audit and examination experience"],
    postedDate: "2025-01-18"
  },
  {
    id: 27,
    title: "UX/UI Designer",
    company: "Design Studio Pro",
    location: "Remote",
    type: "Contract",
    category: "Technology",
    salary: "$90,000 - $115,000",
    description: "Create beautiful, user-centered digital experiences. 6-month contract with possibility of extension.",
    requirements: ["4+ years UX/UI design experience", "Proficiency in Figma, Sketch", "Portfolio demonstrating strong design work", "Understanding of design systems", "User research and usability testing", "Responsive and mobile-first design"],
    postedDate: "2025-01-17"
  },
  {
    id: 28,
    title: "Supply Chain Director",
    company: "Confidential",
    location: "Detroit, MI",
    type: "Permanent",
    category: "Operations",
    salary: "$140,000 - $170,000",
    description: "Strategic leadership role managing end-to-end supply chain operations for manufacturing company.",
    requirements: ["10+ years supply chain experience", "Manufacturing industry background", "Proven leadership skills", "Experience with ERP systems", "Master's degree preferred", "S&OP and demand planning"],
    postedDate: "2025-01-16"
  },
  {
    id: 25,
    title: "Content Marketing Manager",
    company: "Confidential",
    location: "Austin, TX",
    type: "Permanent",
    category: "Marketing",
    salary: "$85,000 - $105,000",
    description: "Develop and execute content strategy to drive brand awareness and lead generation.",
    requirements: ["5+ years content marketing experience", "SEO and analytics expertise", "Excellent writing skills", "Experience managing content teams"],
    postedDate: "2025-01-15"
  },
  {
    id: 26,
    title: "Cybersecurity Analyst",
    company: "Tech Security Inc.",
    location: "Washington, DC",
    type: "Permanent",
    category: "Technology",
    salary: "$110,000 - $140,000",
    description: "Protect critical infrastructure through threat detection and incident response. Government clearance required.",
    requirements: ["4+ years cybersecurity experience", "CISSP or Security+ certification", "Experience with SIEM tools", "Active security clearance preferred"],
    postedDate: "2025-01-14"
  },
  {
    id: 27,
    title: "Business Development Executive",
    company: "Confidential",
    location: "Miami, FL",
    type: "Permanent",
    category: "Sales",
    salary: "$95,000 - $130,000 + Commission",
    description: "Drive new business acquisition and build strategic partnerships in enterprise software space.",
    requirements: ["6+ years B2B sales experience", "Track record of exceeding quotas", "Enterprise software background", "Strong negotiation skills"],
    postedDate: "2025-01-13"
  },
  {
    id: 28,
    title: "Quality Assurance Manager",
    company: "Pharma Research Labs",
    location: "Philadelphia, PA",
    type: "Permanent",
    category: "Operations",
    salary: "$105,000 - $130,000",
    description: "Lead QA team ensuring pharmaceutical products meet regulatory standards and quality specifications.",
    requirements: ["8+ years QA experience in pharmaceuticals", "Knowledge of FDA regulations", "Six Sigma certification preferred", "Strong leadership abilities"],
    postedDate: "2025-01-12"
  },
  {
    id: 25,
    title: "DevOps Engineer",
    company: "Confidential",
    location: "San Jose, CA",
    type: "Permanent",
    category: "Technology",
    salary: "$125,000 - $155,000",
    description: "Build and maintain CI/CD pipelines and cloud infrastructure for high-traffic applications.",
    requirements: ["4+ years DevOps experience", "Expertise in AWS/Azure/GCP", "Kubernetes and Docker proficiency", "Scripting skills (Python, Bash)"],
    postedDate: "2025-01-11"
  },
  {
    id: 26,
    title: "Legal Counsel",
    company: "Confidential",
    location: "Boston, MA",
    type: "Permanent",
    category: "Legal",
    salary: "$145,000 - $180,000",
    description: "Provide legal guidance on corporate matters, contracts, and compliance issues.",
    requirements: ["JD from accredited law school", "5+ years corporate law experience", "Bar admission required", "M&A experience preferred"],
    postedDate: "2025-01-10"
  },
  {
    id: 27,
    title: "Training & Development Manager",
    company: "Education Services Inc.",
    location: "Denver, CO",
    type: "Permanent",
    category: "Human Resources",
    salary: "$80,000 - $100,000",
    description: "Design and deliver training programs to enhance employee skills and performance.",
    requirements: ["5+ years training and development experience", "Instructional design expertise", "Experience with LMS platforms", "Strong presentation skills"],
    postedDate: "2025-01-09"
  },
  {
    id: 28,
    title: "Account Executive - SaaS",
    company: "Growth Tech Solutions",
    location: "Remote",
    type: "Permanent",
    category: "Sales",
    salary: "$75,000 - $95,000 + Commission",
    description: "Sell cloud-based business solutions to mid-market companies. Uncapped commission potential.",
    requirements: ["3+ years SaaS sales experience", "Proven track record of quota achievement", "CRM experience (Salesforce preferred)", "Excellent communication skills"],
    postedDate: "2025-01-08"
  },
  {
    id: 25,
    title: "Electrical Engineer",
    company: "Energy Solutions Corp",
    location: "Houston, TX",
    type: "Permanent",
    category: "Engineering",
    salary: "$95,000 - $120,000",
    description: "Design and implement electrical systems for renewable energy projects.",
    requirements: ["Bachelor's in Electrical Engineering", "PE license preferred", "5+ years experience in power systems", "AutoCAD proficiency"],
    postedDate: "2025-01-07"
  },
  {
    id: 26,
    title: "Customer Success Manager",
    company: "Client Services Pro",
    location: "Nashville, TN",
    type: "Permanent",
    category: "Customer Service",
    salary: "$70,000 - $90,000",
    description: "Drive customer retention and satisfaction through proactive relationship management.",
    requirements: ["3+ years customer success experience", "SaaS background preferred", "Strong problem-solving skills", "Data-driven approach"],
    postedDate: "2025-01-06"
  },
  {
    id: 27,
    title: "Research Scientist",
    company: "BioTech Innovations",
    location: "San Diego, CA",
    type: "Permanent",
    category: "Science",
    salary: "$110,000 - $140,000",
    description: "Conduct cutting-edge research in molecular biology and drug discovery.",
    requirements: ["PhD in Biology, Chemistry, or related field", "3+ years post-doctoral experience", "Publication record", "Lab management experience"],
    postedDate: "2025-01-05"
  },
  {
    id: 28,
    title: "Project Manager - Construction",
    company: "BuildRight Contractors",
    location: "Phoenix, AZ",
    type: "Contract",
    category: "Engineering",
    salary: "$90,000 - $115,000",
    description: "Manage commercial construction projects from planning through completion. 12-month contract.",
    requirements: ["7+ years construction project management", "PMP certification preferred", "Experience with large-scale projects", "Strong leadership skills"],
    postedDate: "2025-01-04"
  }
];

export const services = [
  {
    id: 1,
    title: "Executive Search",
    description: "Connect with top-tier executive talent for C-suite and senior leadership positions. Our rigorous search process ensures you find leaders who drive transformation.",
    icon: "briefcase",
    features: [
      "C-Suite & VP level placements",
      "Industry-specific expertise",
      "Confidential search process",
      "90-day placement guarantee"
    ]
  },
  {
    id: 26,
    title: "Permanent Placement",
    description: "Find the perfect permanent employees for your organization. We match qualified professionals with roles that align with their career goals and your company culture.",
    icon: "users",
    features: [
      "Full-time employee placement",
      "Thorough candidate screening",
      "Cultural fit assessment",
      "Replacement guarantee"
    ]
  },
  {
    id: 27,
    title: "Temporary Staffing",
    description: "Flexible staffing solutions for short-term projects, seasonal demands, or coverage needs. Access pre-screened talent quickly and efficiently.",
    icon: "clock",
    features: [
      "Rapid deployment (24-48 hours)",
      "Flexible duration options",
      "No long-term commitment",
      "Temp-to-perm available"
    ]
  },
  {
    id: 28,
    title: "Staff Failover Service",
    description: "Ensure business continuity during unexpected employee separations. Our staff failover solution provides temporary support to alleviate workload pressures, keeping operations smooth until permanent arrangements are in place.",
    icon: "shield",
    features: [
      "Rapid deployment of support staff for 1–2 weeks",
      "Coverage of minor tasks to reduce strain on existing employees",
      "Flexible transition to standard onboarding once company is ready",
      "Option to retain failover staff for long-term placement"
    ]
  },
  {
    id: 25,
    title: "Talent Lifecycle Management",
    description: "Comprehensive end-to-end talent management from recruitment through retirement. We partner with your HR team to optimize every stage of the employee journey, enhancing retention, development, and workforce planning.",
    icon: "refresh-cw",
    features: [
      "Full employee lifecycle support (hire to retire)",
      "Performance management and career pathing",
      "Succession planning and talent pipeline development",
      "Onboarding, training, and offboarding optimization"
    ]
  },
  {
    id: 26,
    title: "Service Excellence Campaign",
    description: "Recognize and elevate exemplary employees who consistently uphold customer care standards through thick and thin. Our evaluation process ensures outstanding service is celebrated while providing actionable insights for improvement.",
    icon: "award",
    features: [
      "Unannounced & announced on-site evaluations",
      "Customer experience simulations",
      "Professional grading rubric (professionalism, focus, spirit, confidence, kindness)",
      "Actionable feedback for training & recognition"
    ]
  },
  {
    id: 27,
    title: "Contract Staffing",
    description: "Specialized contractors for project-based work. Scale your team up or down based on business needs without the overhead of permanent hires.",
    icon: "file-text",
    features: [
      "Project-based assignments",
      "Specialized skill sets",
      "Flexible contracts",
      "Performance management"
    ]
  },
  {
    id: 28,
    title: "Recruitment Process Outsourcing",
    description: "Comprehensive recruitment management for organizations looking to optimize their hiring process. We become an extension of your HR team.",
    icon: "target",
    features: [
      "End-to-end recruitment management",
      "Scalable solutions",
      "Technology integration",
      "Reduced time-to-hire"
    ]
  },
  {
    id: 25,
    title: "Talent Advisory",
    description: "Strategic workforce planning and talent management consulting. We help you build sustainable talent strategies for long-term success.",
    icon: "trending-up",
    features: [
      "Workforce planning",
      "Market intelligence",
      "Compensation benchmarking",
      "Talent strategy development"
    ]
  }
];

export const stats = [
  { value: "2,500+", label: "Successful Placements" },
  { value: "500+", label: "Client Companies" },
  { value: "95%", label: "Satisfaction Rate" },
  { value: "15+", label: "Years Experience" }
];

export const industries = [
  "Energy & Utilities",
  "Engineering, Procurement & Construction (EPC)",
  "Professional Services & Consulting",
  "Information Technology & Digital Services",
  "Manufacturing & Industrial Operations",
  "Business Development, Marketing, & Sales",
  "Retail & Consumer Goods",
  "Logistics & Supply Chain Management",
  "Hospitality & Leisure"
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    title: "HR Director, Tech Innovators Inc.",
    content: "Munoret helped us find our CTO in just 6 weeks. Their understanding of our needs and culture was exceptional.",
    rating: 5
  },
  {
    id: 26,
    name: "Michael Chen",
    title: "CEO, Startup Ventures",
    content: "The executive search team at Munoret is world-class. They delivered qualified candidates who exceeded our expectations.",
    rating: 5
  },
  {
    id: 27,
    name: "Emily Rodriguez",
    title: "Operations Manager, Global Brands Corp",
    content: "Their temporary staffing solution saved us during our peak season. Professional, reliable, and efficient service.",
    rating: 5
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "David Martinez",
    title: "Founder & CEO",
    bio: "20+ years of experience in talent acquisition and executive search across multiple industries."
  },
  {
    id: 26,
    name: "Jennifer Thompson",
    title: "VP of Operations",
    bio: "Specializes in building scalable recruitment processes and client relationship management."
  },
  {
    id: 27,
    name: "Robert Kim",
    title: "Director of Executive Search",
    bio: "Former corporate recruiter with expertise in C-suite and senior leadership placements."
  },
  {
    id: 28,
    name: "Amanda Foster",
    title: "Head of Technology Practice",
    bio: "Connects top technology talent with innovative companies. 15+ years in tech recruiting."
  }
];
